import html2PDF from 'jspdf-html2canvas';

const buttonPDF = document.querySelector('.action-upload');
const page = document.querySelectorAll('body');

if(buttonPDF !== null){
    buttonPDF.addEventListener('click', function(){

        window.scrollTo(0, 0)

        // Open all details before generate pdf
        const accordionsDetails = document.querySelectorAll('details');
        accordionsDetails.forEach(function (accordionDetail) {
            accordionDetail.open = true
        })

        let newWindow = window.open(document.URL, '_blank')
        html2PDF(
            page,
            {
                margin: 0,
                filename: 'myfile.pdf',
                image: {type: 'jpeg',quality: 0.98},
                html2canvas: {scale: 2},
                jsPDF: {
                    unit: 'px',
                    format: 'letter',
                    orientation: 'portrait'
                }
            }
        ).then(function(){
            newWindow.close()

            // Close all details after generate pdf
            accordionsDetails.forEach(function (accordionDetail) {
                accordionDetail.open = false
            })
        })
    });
}

